import * as AC from 'components/actions/actionTypes';
import _ from 'lodash';
import moment from 'moment';
import InvoiceBookingHelper from 'components/common/helpers/InvoiceBookingHelper';
import BookingReducerHelper from './helpers/BookingReducerHelper';
import { STANDARD } from 'components/common/constants/authConstants';
import PriceList from 'components/common/helpers/PriceList';

let initialState = {
  showSidebar: false,
  startFromBooking: false,
  startDate: {
    value: null,
    label: ''
  },
  endDate: {
    value: null,
    label: ''
  },
  airportCode: null,
  airportFrom: {
    id: null,
    label: '',
    isAirport: false,
    code: null
  },
  airportTo: {
    id: null,
    label: '',
    isAirport: false
  },
  adultsNumber: 1,
  studentsNumber: 0,
  childrenNumber: 0,
  kidsSafety: {
    cradle: 0, //kołyska
    seatWithSeatBelts: 0, //siedzący z pasami
    seatWithoutSeatBelts: 0, //siedzący bez pasów
    carSeatPad: 0, //podkładka
    noNeedCarSeat: 0, //nie potrzebuje fotelika
  },
  departureFlight: null,
  returnFlight: null,
  departureAddress: {
    phrase: '',
    selectedObject: null,
    postcode: null,
    street: null,
    error: null,
    lat: null,
    lng: null
  },
  returnAddress: {
    phrase: '',
    selectedObject: null,
    postcode: null,
    street: null,
    error: null,
    lat: null,
    lng: null
  },
  loadingDataOnMap: false,
  addressChanged: false,
  departurePrice: null,
  returnPrice: null,
  differentReturnAddress: false,
  userData: {
    name: '',
    email: '',
    password: '',
    phone: '',
    phoneCountry: { value: "Norway", label: "+47", code: "NO" },
    type: STANDARD,
    errors: {},
    createAccountWithBooking: false,
    phoneConfirmed: false,
  },
  userNameOverride: '',
  userPhoneOverride: '',
  selectedCardId: null,
  invoiceData: {
    invoiceCompany: '',
    invoiceAddress: '',
    invoiceTaxNumber: '',
    issueInvoiceEachBooking: false,
  },
  sendInvoice: false,

};

export default function reducer(state = initialState, action) {
  switch (action.type) {

    case AC.SHOW_BOOKING_SIDEBAR:
      return _.merge({}, state, { showSidebar: action.showSidebar });

    case AC.START_FROM_BOOKING:
      return _.merge({}, state, { startFromBooking: action.startFromBooking });

    case AC.SET_BOOKING_DATE:
      return _.merge({}, state, action.dateObject);

    case AC.SET_BOOKING_AIRPORT:
      var aObj = action.airportObject;
      var code;
      if (aObj) {
        if (aObj.airportFrom && aObj.airportFrom.code) {
          code = aObj.airportFrom.code;
        } else if (aObj.airportTo && aObj.airportTo.code) {
          code = aObj.airportTo.code;
        }
      }
      var newState = { ...action.airportObject, airportCode: code }
      return _.merge({}, state, newState);

    case AC.SET_ADULTS_NUMBER:
      return _.merge({}, state, { adultsNumber: action.number });

    case AC.SET_CHILDREN_NUMBER:
      return _.merge({}, state, { childrenNumber: action.number });

    case AC.SET_STUDENTS_NUMBER:
      var newState = _.merge({}, state, { studentsNumber: action.number });
      return newState;

    case AC.SET_KIDS_SAFETY_NUMBER:
      return _.merge({}, state, { kidsSafety: action.value });

    case AC.RESET_KIDS_SAFETY_IN_BOOKING:
      var newState = _.merge({}, state);
      newState.kidsSafety = {
        noNeedCarSeat: 0,
        cradle: 0,
        seatWithSeatBelts: 0,
        seatWithoutSeatBelts: 0,
        carSeatPad: 0
      };
      return newState;

    case AC.RESET_FLIGHTS:
      return _.merge({}, state, { departureFlight: null, returnFlight: null });

    case AC.RESET_ADDRESSES:
      return _.merge({}, state, {
        departureAddress: {
          phrase: '',
          selectedObject: null,
          postcode: null,
          street: null,
          error: null,
          lat: null,
          lng: null
        },
        returnAddress: {
          phrase: '',
          selectedObject: null,
          postcode: null,
          street: null,
          error: null,
          lat: null,
          lng: null
        }
      });

    case AC.SET_DEPARTURE_FLIGHT:
      return _.merge({}, state, { departureFlight: action.flight });

    case AC.SET_RETURN_FLIGHT:
      return _.merge({}, state, { returnFlight: action.flight });

    case AC.SET_RETURN_ADDRESS_PHRASE:
      return _.merge({}, state, { returnAddress: { phrase: action.phrase } });

    case AC.SET_RETURN_ADDRESS_OBJECT:
      var newState = _.merge({}, state);
      newState.returnAddress.selectedObject = {};
      return _.merge(
        newState,
        {
          addressChanged: true,
          returnAddress: {
            selectedObject: action.object,
          }
        }
      );

    case AC.SET_DEPARTURE_ADDRESS_PHRASE:
      return _.merge({}, state, { departureAddress: { phrase: action.phrase } });

    case AC.SET_DEPARTURE_ADDRESS_OBJECT:
      var newState = _.merge({}, state);
      newState.departureAddress.selectedObject = {};
      return _.merge(
        newState,
        {
          addressChanged: true,
          departureAddress: {
            selectedObject: action.object
          }
        }
      );

    case AC.SET_DIFFERENT_RETURN_ADDRESS:
      return _.merge({}, state, { differentReturnAddress: action.value });

    case AC.SET_BOOKING_PRICE:
      var bookingHelper = new BookingReducerHelper(state).setPriceList(action.priceList);
      return _.merge(
        {},
        state,
        {
          departurePrice: bookingHelper.getDeparturePrice(),
          returnPrice: bookingHelper.getReturnPrice()
        }
      );

    case AC.SET_DEPARTURE_ADDRESS_POSTCODE_ERROR_LAT_LNG:
      return _.merge(
        {},
        state,
        {
          departureAddress: {
            error: action.error,
            postcode: action.postcode,
            street: action.street,
            lat: action.lat,
            lng: action.lng
          }
        }
      );

    case AC.SET_RETURN_ADDRESS_POSTCODE_ERROR_LAT_LNG:
      return _.merge(
        {},
        state,
        {
          returnAddress: {
            error: action.error,
            postcode: action.postcode,
            street: action.street,
            lat: action.lat,
            lng: action.lng
          }
        }
      );

    case AC.SET_BOOKING_USER_DATA:
      var newState = _.merge({}, state, { userData: action.data });
      var phoneHasChanged = new BookingReducerHelper(state).phoneHasChanged(newState);
      if (phoneHasChanged) {
        newState.userData.phoneConfirmed = false;
      }
      return newState;

    case AC.RESET_BOOKING:
      return _.merge({}, initialState);

    case AC.SET_BOOKING_CARD_ID:
      return _.merge({}, state, { selectedCardId: action.id });

    case AC.SET_INVOICE_FIELD_VALUE:
      var newState = _.merge({}, state, { invoiceData: action.hash });
      var sendInvoice = new InvoiceBookingHelper(newState.invoiceData).sendInvoice();
      newState.sendInvoice = sendInvoice;
      return newState;

    case AC.TOGGLE_BOOKING_SEND_INVOICE:
      return _.merge({}, state, { sendInvoice: !state.sendInvoice });

    case AC.TOGGLE_CREATE_ACCOUNT_IN_BOOKING:
      return _.merge(
        {},
        state,
        { userData: { createAccountWithBooking: !state.userData.createAccountWithBooking } }
      );

    case AC.SET_USER_DATA_ERRORS:
      // reset errors
      var newState = _.merge(
        {},
        state,
        { userData: { errors: initialState.userData.errors } }
      );
      if (action.resetErrors) {
        newState.userData.errors = initialState.userData.errors;
        return newState;
      } else {
        //apply passed errors to new state
        return _.merge(
          newState,
          { userData: { errors: action.errors } }
        );
      }

    case AC.START_LOADING_DATA_ON_MAP:
      return _.merge({}, state, { loadingDataOnMap: true });

    case AC.STOP_LOADING_DATA_ON_MAP:
      return _.merge({}, state, { loadingDataOnMap: false });

    case AC.SET_USER_NAME_OVERRIDE:
      return _.merge({}, state, { userNameOverride: action.value });

    case AC.SET_USER_PHONE_OVERRIDE:
      return _.merge({}, state, { userPhoneOverride: action.value });

    default:
      return state;
  }
}

